import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface StreamCard {
    title: string;
    icon: string;
    buttonText: string;
    streamId?: string;
    dynamicShow: boolean;
}

@Component({
    selector: 'app-stream-card',
    standalone: false,
    templateUrl: './stream-card.component.html',
    styleUrl: './stream-card.component.scss'
})
export class StreamCardComponent {
    @Input({ required: true })
    public title!: string;

    @Input({ required: true })
    public icon!: string;

    @Input({ required: true })
    public buttonText!: string;

    @Input({ required: false })
    public streamId?: string;

    @Output()
    public onClick = new EventEmitter<string | undefined>();
}

